import RBush from 'rbush';
import { useMemo } from 'react';

import { useApplicationContext } from '@/app/shared/context/ApplicationContext';

import { DEFAULT_PROMO_PIN_CONFIG } from '@/microfrontends/map/shared/constants/map';
import { useMapStoreContext } from '@/microfrontends/map/shared/context/mapStoreContext';
import { type RBushItem } from '@/microfrontends/map/shared/types/Map';
import { type TPromoPinConfig } from '@/microfrontends/map/shared/types/PromoPinConfig';

import { useConstant } from '@/packages/react-utils/useConstant';

type UseInitPinsLayerResult = {
  pinsLayer: YMaps.PinsLayer;
  rbush: RBush<RBushItem>;
};

export function useInitPinsLayer(): UseInitPinsLayerResult {
  const { config } = useApplicationContext();

  const { ymaps, map } = useMapStoreContext();

  const rbush = useConstant(() => new RBush<RBushItem>());

  const pinsLayer = useConstant(() => {
    const promoPinConfig = config.get<TPromoPinConfig>('mapSearchFrontend.promoPinConfig') || DEFAULT_PROMO_PIN_CONFIG;

    return new ymaps.PinsLayer({ map, rbush, promoPinConfig });
  });

  return useMemo(() => ({ pinsLayer, rbush }), [pinsLayer, rbush]);
}
